import React, { Fragment } from "react";
import { Icon } from "semantic-ui-react";
import { FieldRendererProps } from "../entity_crud/fieldRenderersEditors";
import { Utils } from "@crispico/foundation-react";

export class GeneratedFilesFieldRenderer extends React.Component<FieldRendererProps> {
    constructor(props: FieldRendererProps) {
        super(props);
    }

    private getFileNames(): string[] {
        const value = this.props.value;
        if (!value || typeof value !== 'string') {
            return [];
        }
        return value.split('|')
            .filter(file => file.trim().length > 0)
            .map(file => Utils.substringAfter(file, ':', true));
    }



    render() {
        const fileNames = this.getFileNames();

        if (fileNames.length === 0) {
            return <span style={{ color: '#999' }}>No files generated</span>;
        }

        return (
            <div>
                {fileNames.map((fileName, index) => {
                    const backgroundTaskId = this.props.entity.id;
                    const url = `/api/background-tasks/${backgroundTaskId}/files/${index}`;

                    return (
                        <Fragment key={index}>
                            <a href={url} target="_blank" rel="noopener noreferrer" data-testId={`file-${index}`}>
                                <Icon name="download" /> {fileName}
                            </a>
                            {index < fileNames.length - 1 && ", "}
                        </Fragment>
                    );
                })}
            </div>
        );
    }
}

export default GeneratedFilesFieldRenderer;
"./.."